import { z } from "zod";

export const ComplaintSchema = z.object({
    id: z.number().positive().min(1),
    stageId: z.number().positive().min(1),
    description: z.string().max(10240).nullable().optional(),
    startDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val), z.date().nullish()),
    endDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val), z.date().nullish()),
    createdBy: z.number().positive().min(1),
    createdOn: z.date(),
    modifiedBy: z.number().positive().min(1),
    modifiedOn: z.date(),
});

export type Complaint = z.infer<typeof ComplaintSchema>;
